import { Progress } from '@agro-club/agroclub-shared'
import { useTableData } from 'modules/domain/common/hooks'
import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { useEffect, useMemo, useState } from 'react'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { Trailer } from '../../types'

export const useTrailers = (carrierId: number) => {
  const [listRequestParams, setListRequestParams] = useState<ListRequestParams>({
    ...defaultListRequestParams,
    filter: { carrier: carrierId },
    pageSize: 10,
  })

  const { data, refetch, progress, total } = useTableData<Trailer>(
    endpoints.LogisticsKR.activeTrailers(),
    listRequestParams,
    !!listRequestParams.filter.carrier,
  )

  const [countForDisplay, setCountForDisplay] = useState<number>()
  useEffect(() => {
    if (progress !== Progress.SUCCESS) return
    if (listRequestParams.filter.search) return
    setCountForDisplay(total)
  }, [total, listRequestParams, progress])

  return useMemo(
    () => ({
      data,
      refetch,
      progress,
      total,
      listRequestParams,
      setListRequestParams,
      countForDisplay,
    }),
    [data, refetch, progress, total, listRequestParams, countForDisplay],
  )
}
